/**
 * === Cart drawer > login & register popup
 */

window.addEventListener("DOMContentLoaded", () => {

  // === Login popup
	
  const loginPopup = document.querySelector('[data-sidecart-popup-login]');
  const loginPopupToggles = document.querySelectorAll('[data-sidecart-popup-login-toggle]');

  if (loginPopup !== null && loginPopup !== undefined && loginPopupToggles.length > 0) {

    loginPopupToggles.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault;
        e.stopPropagation();

        loginPopup.classList.toggle('active');
      })
    });
    
  }

  // === Register popup

  const registerPopup = document.querySelector('[data-sidecart-popup-register]');
  const registerPopupToggles = document.querySelectorAll('[data-sidecart-popup-register-toggle]');

  if (registerPopup !== null && registerPopup !== undefined && registerPopupToggles.length > 0) {

    registerPopupToggles.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault;
        e.stopPropagation();

        registerPopup.classList.toggle('active');
      })
    });
    
  }

});